import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  CircularProgress,
} from "@mui/material";
import { firestore } from "../firebase";
import { getAuth } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

const SupportPage = () => {
  const [loading, setLoading] = useState(true);
  const [affiliateInfo, setAffiliateInfo] = useState(null);

  useEffect(() => {
    const fetchSupportData = async () => {
      try {
        const auth = getAuth();
        const user = auth.currentUser;
        if (!user) return;

        const userRef = doc(firestore, "users", user.uid);
        const userSnap = await getDoc(userRef);
        const shopSlug = userSnap.data()?.shopId;

        const shopRef = doc(firestore, "rentalShops", shopSlug);
        const shopSnap = await getDoc(shopRef);

        const name = shopSnap.data()?.support?.contactName;
        const phone = shopSnap.data()?.support?.phone;

        if (name && phone) {
          setAffiliateInfo({ name, phone });
        }
      } catch (err) {
        console.error("Error loading support info:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSupportData();
  }, []);

  if (loading) {
    return (
      <Container maxWidth="sm" sx={{ textAlign: "center", mt: 10 }}>
        <CircularProgress />
        <Typography sx={{ mt: 2 }}>Loading support info...</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 5 }}>
      <Typography variant="h4" gutterBottom>
        Support
      </Typography>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6">Your Support Agent</Typography>
        {affiliateInfo ? (
          <Box>
            <Typography>Name: {affiliateInfo.name || "N/A"}</Typography>
            <Typography>Phone: {affiliateInfo.phone || "N/A"}</Typography>
          </Box>
        ) : (
          <Typography>No affiliate assigned to your shop.</Typography>
        )}
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6">Email Support</Typography>
        <Typography>
          Email us anytime at <strong>support@ridecan.com</strong>
        </Typography>
      </Paper>
    </Container>
  );
};

export default SupportPage;
